import { MdOutlineSchool } from "react-icons/md";

export default function SchoolIcon({size}) {
    return <MdOutlineSchool size={size} />;
}
